import React from 'react';
import Header from '../components/Header';
import SEO from '../components/SEO';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="page-container">
      <SEO page="aboutUs" />
      <Header />
      <main className="main-content full-width">
        <section className="about-section">
          <h2>关于我们</h2>
          <div className="content-wrapper">
            <p>我们是一家致力于儿童阅读推广的专业机构，专注于为3-12岁儿童提供优质的阅读体验和成长环境。</p>
            <p>自2022年成立以来，我们始终秉持着"阅读·游戏·自然"的理念，通过创新的方式激发孩子们的阅读兴趣。</p>
            <p>我们相信阅读不仅仅是获取知识的方式，更是连接世界的桥梁。为此，我们开创性地将阅读与游戏、自然相结合：</p>
            <ul>
              <li>通过互动游戏让阅读变得生动有趣</li>
              <li>在自然环境中开展户外阅读课程</li>
              <li>设计沉浸式阅读体验空间</li>
            </ul>
            <p>展望未来，我们将继续深耕自然与互动阅读：</p>
            <ul>
              <li>打造自然系的故事会，在树荫下、在野外探索丰富的沉浸式体验和阅读活动</li>
              <li>开发自然探索阅读课程，结合动植物观察与绘本阅读</li>
              <li>设计户外阅读游戏，通过角色扮演和寻宝活动激发阅读兴趣</li>
              <li>建立自然阅读花园，让孩子们在花香鸟语中享受阅读时光</li>
              <li>开展亲子自然阅读营，促进家庭共读与自然探索的结合</li>
            </ul>
            
            <div className="timeline-section">
              <h3>发展历程</h3>
              <ul className="timeline">
                <li>
                  {/* <span className="year">2022</span> */}
                  <p> 2022 机构成立，专注于儿童阅读推广</p>
                </li>
                <li>
                  {/* <span className="year">2023</span> */}
                  <p> 2023 获得"最佳阅读推广机构"称号</p>
                </li>
                <li>
                  {/* <span className="year">2024</span> */}
                  <p> .. 更多活动开展中</p>
                </li>
              </ul>
            </div>

            <div className="team-section">
              <h3>核心团队</h3>
              <div className="team-grid">
                <div className="team-member">
                  <img 
                    src="/images/team1.jpg" 
                    alt="团队1" 
                    width="200" 
                    height="200"
                    loading="lazy"
                  />
                  <h4>小姚</h4>
                  <p>专业指导师</p>
                </div>
                <div className="team-member">
                  <img 
                    src="/images/team2.jpg" 
                    alt="团队2"
                    width="200" 
                    height="200"
                    loading="lazy"
                  />
                  <h4>小乔</h4>
                  <p>日常陪伴老师</p>
                </div>
              </div>
            </div>

            <div className="achievements-section">
              <h3>过去</h3>
              <ul>
                <li>连续2年获得"优秀公益组织"称号</li>
                <li>累计服务超过100名儿童</li>
                <li>与10+知名出版社建立合作关系</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AboutUs;
